import Button from "components/base/Button";
import { Input, NativeDatePicker, Select } from "components/base/Form";
import FactorySelector from "components/shared/FactorySelector";
import { BsTrash } from "react-icons/bs";

const ProductPriceRow = ({ price, onChange, onDelete }) => {
  return (
    <tr>
      <td>
        <div className="flex space-x-2 items-center">
          <Button danger onClick={onDelete}>
            <BsTrash />
          </Button>
          <Select
            value={price.company}
            onChange={(e) => onChange("company", e.target.value)}
          >
            <option>AB</option>
            <option>LTD</option>
          </Select>
        </div>
      </td>
      <td>
        <FactorySelector
          allowedNull={false}
          value={price.factoryId || "0"}
          onChange={(v) => onChange("factoryId", v)}
        />
      </td>
      <td className="text-right">
        <Input
          number
          className="text-right w-20"
          value={price.minQty}
          onChange={(e) => onChange("minQty", e.target.value)}
        />
      </td>
      <td className="text-right">
        <Input
          number
          className="text-right w-20"
          value={price.price}
          onChange={(e) => onChange("price", e.target.value)}
        />
      </td>
      <td className="text-right">
        <Select
          value={price.currency}
          onChange={(e) => onChange("currency", e.target.value)}
        >
          <option value="USD">USD</option>
          <option value="RMB">RMB</option>
        </Select>
      </td>
      <td className="text-right">
        <NativeDatePicker
          value={price.supplierUpdatedAt || ""}
          onChange={(e) => onChange("supplierUpdatedAt", e.target.value)}
        />
      </td>
    </tr>
  );
};

export default ProductPriceRow;
